import { Button } from '@mui/material';

import { GDMButtonComponent } from './GDMButton.type';

/* TODO: Implement component using GDM default design */
const GDMButton: GDMButtonComponent = props => <Button {...props} />;

export default GDMButton;
